import dayjs from "dayjs";

// admin은 만료와 무관하게 항상 라이센스 보유로 간주.
// 일반 user는 *_expiration이 오늘 이후인 경우에만 라이센스 유효.

export function hasKlaLicense(user) {
  if (!user) return false;
  if (user.role === "admin") return true;
  return !!user.kla_expiration && dayjs(user.kla_expiration).isAfter(dayjs());
}

export function hasSleLicense(user) {
  if (!user) return false;
  if (user.role === "admin") return true;
  return !!user.sle_expiration && dayjs(user.sle_expiration).isAfter(dayjs());
}
